var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-nav"},_vm._l((_vm.data),function(t,i){return _c('div',{key:i,staticClass:"nav-item",on:{"click":function($event){return _vm.$router.push(t.path)}}},[_c('div',[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"iconfont",class:t.icon})])]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(t.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }